import React, { memo } from 'react';
import { Router, Switch } from 'react-router-dom';
import {
    AufmasPage,
    BenutzerProfil,
    FAQ,
    MaterialPage,
    OrganisationManagement,
    ProjectPage,
    ProjectsOverview,
    TextTemplatePage,
    NewTextTemplatePage,
    Training,
} from '../Pages';
import TagesberichtPage from '../Pages/TagesberichtPage';
import ForgotPassword from '../Pages/forgotpassword';
import Login from '../Pages/Login';
import OTPPage from '../Pages/otppage';
import ProductManagementPage from '../Pages/ProductManagementPage';
import history from '../Utils/history';
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './PublicRoutes';
import BenutzerManagementPage from "../Pages/BenutzerManagementPage";
import AnalyseRequestPage from "../Pages/AnalyseRequestPage";
import LVhochladen from "../Pages/LVhochladen";
import KeywordToolPage from "../Pages/KeywordToolPage";
import DatatoolPage from "../Pages/DatatoolPage";
import QADatasetBuilderPage from "../Pages/QADatasetBuilderPage";
import DatatoolViewPage from "../Pages/DatatoolViewPage";
import AnnotatorPage from "../Pages/AnnotatorPage";
import LvAnalyseStatusPage from "../Pages/LvAnalyseStatusPage";
import WebReport from "../Pages/WebReport";
import TaetigkeitsberichtPage from "../Pages/TaetigkeitsberichtPage";
import GeraetePage from "../Pages/GeraetePage";
import MetaOverview from '../Pages/MetaOverview';
import StundenPage from "../Pages/StundenPage";
import AppWebReport from "../Pages/AppWebReport"
import TagesberichtReportPage from "../Pages/TagesberichtReportPage";

function Routes() {

    return (
        <Router history={history}>

            <Switch>
                <PublicRoutes
                    component={Login}
                    path={process.env.REACT_APP_FRONTEND_PATH_LOGIN}
                    exact
                />
                <PublicRoutes
                    component={ForgotPassword}
                    path={process.env.REACT_APP_FRONTEND_PATH_FORGOTPWD}
                    exact
                />
                <PublicRoutes
                    component={OTPPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_OTPPAGE}
                    exact
                />

                <PublicRoutes
                    component={AppWebReport}
                    path={process.env.REACT_APP_FRONTEND_PATH_APPWEBREPORT}
                    exact
                />

                <PrivateRoutes
                    component={ProductManagementPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_PRODUCTMANAGEMENTPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_PRODUCTMANAGEMENTPAGE}
                    //rsl={role.some( i => ["Handwai-Super-Admin"].includes(i) )}
                    allowedRoles={["Handwai-Super-Admin"]}
                    exact
                />
                <PrivateRoutes
                    component={OrganisationManagement}
                    path={
                        process.env.REACT_APP_FRONTEND_PATH_ORGANISATIONMANAGENTPAGE
                    }
                    title={
                        process.env.REACT_APP_FRONTEND_TITLE_ORGANISATIONMANAGENTPAGE
                    }
                    //rsl={role.some( i => ["Handwai-Super-Admin"].includes(i) )}
                    allowedRoles={["Handwai-Super-Admin"]}
                    exact
                />
                <PrivateRoutes
                    component={BenutzerProfil}
                    path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
                    exact
                    //rsl={role.some( i => ["Handwai-Super-Admin","LV-Uploader"].includes(i) )}
                    allowedRoles={["Handwai-Super-Admin", "Handwai-Org-Admin",
                        "Handwai-LV-Analyst", "Org-Admin", "LV-Uploader", "LV-Kalkulator",
                        "Bauablauf-PL", "Bauablauf-Assistenz", "Bauablauf-Monteur",
                        "Handwai-PL", "Handwai-Assistenz", "Handwai-Monteur",
                    ]}
                />
                <PrivateRoutes
                    component={FAQ}
                    path={process.env.REACT_APP_FRONTEND_PATH_FAQ}
                    title={process.env.REACT_APP_FRONTEND_TITLE_FAQ}
                    exact
                    //rsl={role.some( i => ["Handwai-Super-Admin","LV-Uploader"].includes(i) )}
                    allowedRoles={["Handwai-Super-Admin", "Handwai-Org-Admin",
                        "Handwai-LV-Analyst", "Org-Admin", "LV-Uploader", "LV-Kalkulator",
                        "Bauablauf-PL", "Bauablauf-Assistenz", "Bauablauf-Monteur",
                        "Handwai-PL", "Handwai-Assistenz", "Handwai-Monteur"
                    ]}
                />
                <PrivateRoutes
                    component={Training}
                    path={process.env.REACT_APP_FRONTEND_PATH_TRAINING}
                    title={process.env.REACT_APP_FRONTEND_TITLE_TRAINING}
                    exact
                    allowedRoles={[
                        //"Handwai-LV-Analyst", "LV-Uploader", "LV-Kalkulator",
                        "Handwai-LV-Analyst", "LV-Kalkulator"
                    ]}
                />

                <PrivateRoutes
                    component={BenutzerManagementPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERMANAGENTPAGE}
                    exact
                    allowedRoles={["Handwai-Org-Admin", "Org-Admin"]}
                />

                <PrivateRoutes
                    component={AnalyseRequestPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_ANALYSEREQUESTPAGE}
                    exact
                    allowedRoles={["Handwai-LV-Analyst", "LV-Kalkulator"]}
                    //actualRoles = {actualRoles}
                />
                <PrivateRoutes
                    component={LVhochladen}
                    path={process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}
                    title={process.env.REACT_APP_FRONTEND_TITLE_LVHOCHLADEN}
                    exact
                    allowedRoles={["Handwai-LV-Analyst", "LV-Uploader"]}
                    //actualRoles = {actualRoles}
                />
                <PrivateRoutes
                    component={KeywordToolPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_TOOLPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_TOOLPAGE}
                    exact
                    allowedRoles={["Handwai-LV-Analyst"]}
                    //actualRoles = {actualRoles}
                />
                <PrivateRoutes
                    component={DatatoolPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_DATATOOLPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_DATATOOLPAGE}
                    exact
                    allowedRoles={["Handwai-LV-Analyst"]}
                    //actualRoles = {actualRoles}
                />
                <PrivateRoutes
                    component={QADatasetBuilderPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_QADATASETBUILDERPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_QADATASETBUILDERPAGE}
                    exact
                    allowedRoles={["Handwai-LV-Analyst"]}
                    //actualRoles = {actualRoles}
                />
                <PrivateRoutes
                    component={DatatoolViewPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_DATATOOLVIEWPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_DATATOOLVIEWPAGE}
                    exact
                    allowedRoles={["Handwai-LV-Analyst"]}
                    //actualRoles = {actualRoles}
                />
                <PrivateRoutes
                    component={AnnotatorPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_ANNOTATORPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_ANNOTATORPAGE}
                    exact
                    allowedRoles={["Handwai-LV-Analyst"]}
                    //actualRoles = {actualRoles}
                />
                <PrivateRoutes
                    component={LvAnalyseStatusPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_LVANALYSESTATUSPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_LVANALYSESTATUSPAGE}
                    exact
                    allowedRoles={["Handwai-LV-Analyst"]}
                    //actualRoles = {actualRoles}
                />
                <PrivateRoutes
                    component={WebReport}
                    path={process.env.REACT_APP_FRONTEND_PATH_WEBREPORT}
                    exact
                    allowedRoles={["Handwai-LV-Analyst", "LV-Kalkulator"]}
                    //actualRoles = {actualRoles}
                />

                <PrivateRoutes
                    component={ProjectsOverview}
                    path={process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_PROJECTSOVERVIEWPAGE}
                    exact
                    allowedRoles={["Bauablauf-PL", "Handwai-PL",
                        "Bauablauf-Assistenz", "Handwai-Assistenz"]}
                />

                <PrivateRoutes
                    component={ProjectPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_PROJECTPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_PROJECTPAGE}
                    exact
                    allowedRoles={["Bauablauf-Assistenz", "Handwai-Assistenz",
                        "Bauablauf-PL", "Handwai-PL"]}
                />

                <PrivateRoutes
                    component={AufmasPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_AUFMASPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_AUFMASPAGE}
                    exact
                    allowedRoles={["Bauablauf-Assistenz", "Handwai-Assistenz",
                        "Bauablauf-PL", "Handwai-PL"]}
                />

                {/* ADDED BY ASIFOR KINGSLEY */}
                <PrivateRoutes
                    component={TextTemplatePage}
                    path={process.env.REACT_APP_FRONTEND_PATH_TEXT_TEMPLATE}
                    title={process.env.REACT_APP_FRONTEND_TEXT_TEMPLATE}
                    exact
                    allowedRoles={["Bauablauf-Assistenz", "Handwai-Assistenz",
                        "Bauablauf-PL", "Handwai-PL"]}
                />
                <PrivateRoutes
                    component={NewTextTemplatePage}
                    path={process.env.REACT_APP_FRONTEND_PATH_NEW_TEXT_TEMPLATE_TEXT}
                    title={process.env.REACT_APP_FRONTEND_NEW_TEXT_TEMPLATE_TEXT}
                    exact
                    allowedRoles={["Bauablauf-Assistenz", "Handwai-Assistenz",
                        "Bauablauf-PL", "Handwai-PL"]}
                />

                <PrivateRoutes
                    component={MaterialPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_MATERIALPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_MATERIALPAGE}
                    exact
                    allowedRoles={["Bauablauf-PL", "Handwai-PL"]}
                />

                <PrivateRoutes
                    component={TaetigkeitsberichtPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_TAETIGKEITSBERICHTPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_TAETIGKEITSBERICHTPAGE}
                    exact
                    allowedRoles={["Bauablauf-PL", "Handwai-PL"]}
                />

                <PrivateRoutes
                    component={TagesberichtPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_TAGESBERICHTPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_TAGESBERICHTPAGE}
                    exact
                    allowedRoles={["Bauablauf-PL", "Handwai-PL"]}
                />

                <PrivateRoutes
                    component={TagesberichtReportPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_TAGESBERICHTREPORTPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_TAGESBERICHTREPORTPAGE}
                    exact
                    allowedRoles={["Bauablauf-PL", "Handwai-PL"]}
                />

                <PrivateRoutes
                    component={StundenPage}
                    path={process.env.REACT_APP_FRONTEND_PATH_STUNDENPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_STUNDENPAGE}
                    exact
                    allowedRoles={["Bauablauf-PL", "Handwai-PL"]}
                />

                <PrivateRoutes
                    component={MetaOverview}
                    path={process.env.REACT_APP_FRONTEND_PATH_METAOVERVIEWPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_METAOVERVIEWPAGE}
                    exact
                    allowedRoles={["Bauablauf-PL", "Handwai-PL"]}
                />

                <PrivateRoutes
                    component={GeraetePage}
                    path={process.env.REACT_APP_FRONTEND_PATH_GERAETEPAGE}
                    title={process.env.REACT_APP_FRONTEND_TITLE_GERAETEPAGE}
                    exact
                    allowedRoles={["Bauablauf-Assistenz", "Handwai-Assistenz"]}
                />
            </Switch>
        </Router>
    );
}

export default memo(Routes);


// old backup
// import React, {memo} from 'react';
// import {Router, Switch} from 'react-router-dom';
// import {
//     //AnalysenPage,
//     AnalyseRequestPage,
//     AnnotatorPage,
//     BenutzerManagementPage,
//     BenutzerProfil,
//     //Dashboard,
//     FAQ,
//     LVhochladen,
//     MaterialPage,
//     OrganisationManagement,
//     ProjectPage,
//     WebReport,
//     LvAnalyseStatusPage
// } from '../Pages';
// //import BautagebuchPage from '../Pages/BautagebuchPage';
// import ForgotPassword from '../Pages/forgotpassword';
// import LandingPage from '../Pages/LandingPage';
// import Login from '../Pages/Login';
// import OTPPage from '../Pages/otppage';
// import ProductManagementPage from '../Pages/ProductManagementPage';
// import {
//     isAdmin,
//     isAnalyst, isAssistenz,
//     isCalculator,
//     //isLoggedIn,
//     //isMobileAppUser,
//     isMonteur, isPL,
//     isSuperAdmin, isUploader
// } from '../Utils';
// import history from '../Utils/history';
// import PrivateRoutes from './PrivateRoutes';
// //import ProtectedRoutes from './ProtectedRoutes';
// import PublicRoutes from './PublicRoutes';
// import KeywordToolPage from "../Pages/KeywordToolPage";
// import DatatoolPage from '../Pages/DatatoolPage'
// import TaetigkeitsberichtPage from '../Pages/TaetigkeitsberichtPage';
// import ProjectsOverview from '../Pages/ProjectsOverview';
// //import MetaOverview from '../Pages/MetaOverview';
// //import GeraetePage from "../Pages/GeraetePage";
//
// //import LvAnalyseStatusPage from '../Pages/LvAnalyseStatusPage';
//
//
// /*
//     Here is the list of accessible routes to our 'Handwai Platform.
//  */
//
// function Routes() {
//
//     return (
//         <Router history={history}>
//
//             <Switch>
//                 <PublicRoutes
//                     component={LandingPage}
//                     path={process.env.REACT_APP_FRONTEND_PATH_LANDINGPAGE}
//                     exact
//                 />
//                 <PublicRoutes
//                     component={Login}
//                     path={process.env.REACT_APP_FRONTEND_PATH_LOGIN}
//                     exact
//                 />
//                 <PublicRoutes
//                     component={ForgotPassword}
//                     path={process.env.REACT_APP_FRONTEND_PATH_FORGOTPWD}
//                     exact
//                 />
//                 <PublicRoutes
//                     component={OTPPage}
//                     path={process.env.REACT_APP_FRONTEND_PATH_OTPPAGE}
//                     exact
//                 />
//                 {/*<PublicRoutes*/}
//                 {/*    component={LandingPage}*/}
//                 {/*    path={process.env.REACT_APP_FRONTEND_PATH_LANDINGPAGE}*/}
//                 {/*    exact*/}
//                 {/*/>*/}
//
//                 {/*{!isMobileAppUser() && (*/}
//                 {/*    <PrivateRoutes*/}
//                 {/*        component={Dashboard}*/}
//                 {/*        path={process.env.REACT_APP_FRONTEND_PATH_DASHBOARD}*/}
//                 {/*        title={process.env.REACT_APP_FRONTEND_TITLE_DASHBOARD}*/}
//                 {/*        exact*/}
//                 {/*    />*/}
//                 {/*)}*/}
//                 {(isSuperAdmin()) && (
//                     <>
//                         <PrivateRoutes
//                             component={ProductManagementPage}
//                             path={process.env.REACT_APP_FRONTEND_PATH_PRODUCTMANAGEMENTPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_PRODUCTMANAGEMENTPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={OrganisationManagement}
//                             path={
//                                 process.env.REACT_APP_FRONTEND_PATH_ORGANISATIONMANAGENTPAGE
//                             }
//                             title={
//                                 process.env.REACT_APP_FRONTEND_TITLE_ORGANISATIONMANAGENTPAGE
//                             }
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={BenutzerProfil}
//                             path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={FAQ}
//                             path={process.env.REACT_APP_FRONTEND_PATH_FAQ}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_FAQ}
//                             exact
//                         />
//                     </>
//                 )}
//                 {isAdmin() && (
//                     <>
//                         <PrivateRoutes
//                             component={BenutzerManagementPage}
//                             path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERMANAGENTPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={BenutzerProfil}
//                             path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={FAQ}
//                             path={process.env.REACT_APP_FRONTEND_PATH_FAQ}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_FAQ}
//                             exact
//                         />
//                     </>
//                 )}
//
//                 {(isAnalyst()) &&  (
//                      <>
//                         <PrivateRoutes
//                             component={AnalyseRequestPage}
//                             path={process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_ANALYSEREQUESTPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={LVhochladen}
//                             path={process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_LVHOCHLADEN}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={KeywordToolPage}
//                             path={process.env.REACT_APP_FRONTEND_PATH_TOOLPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_TOOLPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={DatatoolPage}
//                             path={process.env.REACT_APP_FRONTEND_PATH_DATATOOLPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_DATATOOLPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={AnnotatorPage}
//                             path={process.env.REACT_APP_FRONTEND_PATH_ANNOTATORPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_ANNOTATORPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={LvAnalyseStatusPage}
//                             path={process.env.REACT_APP_FRONTEND_PATH_LVANALYSESTATUSPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_LVANALYSESTATUSPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={BenutzerProfil}
//                             path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={FAQ}
//                             path={process.env.REACT_APP_FRONTEND_PATH_FAQ}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_FAQ}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={WebReport}
//                             path={process.env.REACT_APP_FRONTEND_PATH_WEBREPORT}
//                             exact
//                         />
//                     </>
//                 )}
//
//                 {isMonteur() && (
//                     <>
//                         <PrivateRoutes
//                             component={BenutzerProfil}
//                             path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={FAQ}
//                             path={process.env.REACT_APP_FRONTEND_PATH_FAQ}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_FAQ}
//                             exact
//                         />
//                     </>
//                 )}
//
//                 {isAssistenz() && (
//                     <>
//                         <PrivateRoutes
//                             component={ProjectsOverview}
//                             path={process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_PROJECTSOVERVIEWPAGE}
//                             exact
//                         />
//
//                         <PrivateRoutes
//                             component={ProjectPage}
//                             path={process.env.REACT_APP_FRONTEND_PATH_PROJECTPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_PROJECTPAGE}
//                             exact
//                         />
//
//                         <PrivateRoutes
//                             component={MaterialPage}
//                             path={process.env.REACT_APP_FRONTEND_PATH_MATERIALPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_MATERIALPAGE}
//                             exact
//                         />
//
//                         <PrivateRoutes
//                             component={BenutzerProfil}
//                             path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={FAQ}
//                             path={process.env.REACT_APP_FRONTEND_PATH_FAQ}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_FAQ}
//                             exact
//                         />
//                     </>
//                 )}
//
//                 {isPL() && (
//                     <>
//                         <PrivateRoutes
//                             component={ProjectsOverview}
//                             path={process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_PROJECTSOVERVIEWPAGE}
//                             exact
//                         />
//
//                         <PrivateRoutes
//                             component={TaetigkeitsberichtPage}
//                             path={process.env.REACT_APP_FRONTEND_PATH_TAETIGKEITSBERICHTPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_TAETIGKEITSBERICHTPAGE}
//                             exact
//                         />
//
//                         <PrivateRoutes
//                             component={BenutzerProfil}
//                             path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={FAQ}
//                             path={process.env.REACT_APP_FRONTEND_PATH_FAQ}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_FAQ}
//                             exact
//                         />
//                     </>
//                 )}
//
//                 {isCalculator() && (
//                     <>
//                         <PrivateRoutes
//                             component={AnalyseRequestPage}
//                             path={process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_ANALYSEREQUESTPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={WebReport}
//                             path={process.env.REACT_APP_FRONTEND_PATH_WEBREPORT}
//                             exact
//                         />
//
//                         <PrivateRoutes
//                             component={BenutzerProfil}
//                             path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={FAQ}
//                             path={process.env.REACT_APP_FRONTEND_PATH_FAQ}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_FAQ}
//                             exact
//                         />
//                     </>
//                 )}
//
//                 {isUploader() && (
//                     <>
//                         <PrivateRoutes
//                             component={LVhochladen}
//                             path={process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_LVHOCHLADEN}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={BenutzerProfil}
//                             path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
//                             exact
//                         />
//                         <PrivateRoutes
//                             component={FAQ}
//                             path={process.env.REACT_APP_FRONTEND_PATH_FAQ}
//                             title={process.env.REACT_APP_FRONTEND_TITLE_FAQ}
//                             exact
//                         />
//                     </>
//                 )}
//
//
//
//
//
//
//
//
//
//                 {/*/!*{!(isSuperAdmin() || isAnalyst()) && (*!/*/}
//                 {/*/!*    <PrivateRoutes*!/*/}
//                 {/*/!*        component={LandingPage}*!/*/}
//                 {/*/!*        path={process.env.REACT_APP_FRONTEND_PATH_DASHBOARD}*!/*/}
//                 {/*/!*        title={process.env.REACT_APP_FRONTEND_TITLE_DASHBOARD}*!/*/}
//                 {/*/!*        exact*!/*/}
//                 {/*/!*    />*!/*/}
//                 {/*/!*)}*!/*/}
//                 {/*/!*{isLoggedIn() && (isSuperAdmin() || isAnalyst() || isCalculator()) && (*!/*/}
//
//                 {/*/!*{isLoggedIn() && (isLVUploader()) && (*!/*/}
//                 {/*/!*    <PrivateRoutes*!/*/}
//                 {/*/!*        component={LVhochladen}*!/*/}
//                 {/*/!*        path={process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}*!/*/}
//                 {/*/!*        title={process.env.REACT_APP_FRONTEND_TITLE_LVHOCHLADEN}*!/*/}
//                 {/*/!*        exact*!/*/}
//                 {/*/!*    />*!/*/}
//                 {/*/!*)}*!/*/}
//
//                 {/*{(isAnalyst() || isCalculator()) && (*/}
//                 {/*    <PrivateRoutes*/}
//                 {/*        component={AnalysenPage}*/}
//                 {/*        path={process.env.REACT_APP_FRONTEND_PATH_ANALYSENPAGE}*/}
//                 {/*        title={process.env.REACT_APP_FRONTEND_TITLE_ANALYSENPAGE}*/}
//                 {/*        exact*/}
//                 {/*    />*/}
//                 {/*)}*/}
//                 {/*{isAnalyst() && (*/}
//                 {/*    <PrivateRoutes*/}
//                 {/*        component={KeywordToolPage}*/}
//                 {/*        path={process.env.REACT_APP_FRONTEND_PATH_TOOLPAGE}*/}
//                 {/*        title={process.env.REACT_APP_FRONTEND_TITLE_TOOLPAGE}*/}
//                 {/*        exact*/}
//                 {/*    />*/}
//                 {/*)}*/}
//                 {/*{isAnalyst() && (<PrivateRoutes*/}
//                 {/*        component={DatatoolPage}*/}
//                 {/*        path={process.env.REACT_APP_FRONTEND_PATH_DATATOOLPAGE}*/}
//                 {/*        title={process.env.REACT_APP_FRONTEND_TITLE_DATATOOLPAGE}*/}
//                 {/*        exact*/}
//                 {/*    />*/}
//                 {/*)}*/}
//                 {/*{isAnalyst() && (*/}
//                 {/*    <PrivateRoutes*/}
//                 {/*        component={AnnotatorPage}*/}
//                 {/*        path={process.env.REACT_APP_FRONTEND_PATH_ANNOTATORPAGE}*/}
//                 {/*        title={process.env.REACT_APP_FRONTEND_TITLE_ANNOTATORPAGE}*/}
//                 {/*        exact*/}
//                 {/*    />*/}
//                 {/*)}*/}
//                 {/*{isAnalyst() && (*/}
//                 {/*    <PrivateRoutes*/}
//                 {/*        component={LvAnalyseStatusPage}*/}
//                 {/*        path={process.env.REACT_APP_FRONTEND_PATH_LVANALYSESTATUSPAGE}*/}
//                 {/*        title={process.env.REACT_APP_FRONTEND_TITLE_LVANALYSESTATUSPAGE}*/}
//                 {/*        exact/>*/}
//                 {/*)}*/}
//                 {/*<PrivateRoutes*/}
//                 {/*    component={BenutzerProfil}*/}
//                 {/*    path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}*/}
//                 {/*    title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}*/}
//                 {/*    exact*/}
//                 {/*/>*/}
//
//                 {/*{!isMobileAppUser() ? (*/}
//                 {/*    <>*/}
//                 {/*        <PrivateRoutes*/}
//                 {/*            component={FAQ}*/}
//                 {/*            path={process.env.REACT_APP_FRONTEND_PATH_FAQ}*/}
//                 {/*            title={process.env.REACT_APP_FRONTEND_TITLE_FAQ}*/}
//                 {/*            exact*/}
//                 {/*        />*/}
//                 {/*        <PrivateRoutes*/}
//                 {/*            component={WebReport}*/}
//                 {/*            path={process.env.REACT_APP_FRONTEND_PATH_WEBREPORT}*/}
//                 {/*            exact*/}
//                 {/*        />*/}
//                 {/*        <PrivateRoutes*/}
//                 {/*            component={BenutzerProfil}*/}
//                 {/*            path={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}*/}
//                 {/*            title={process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}*/}
//                 {/*            exact*/}
//                 {/*        />*/}
//                 {/*    </>*/}
//                 {/*) : (*/}
//                 {/*    <>*/}
//                 {/*        <PrivateRoutes*/}
//                 {/*            component={ProjectsOverview}*/}
//                 {/*            path={process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE}*/}
//                 {/*            title={process.env.REACT_APP_FRONTEND_TITLE_PROJECTSOVERVIEWPAGE}*/}
//                 {/*            exact*/}
//                 {/*        />*/}
//                 {/*        <PrivateRoutes*/}
//                 {/*            component={MetaOverview}*/}
//                 {/*            path={process.env.REACT_APP_FRONTEND_PATH_METAOVERVIEWPAGE}*/}
//                 {/*            title={process.env.REACT_APP_FRONTEND_TITLE_METAOVERVIEWPAGE}*/}
//                 {/*            exact*/}
//                 {/*        />*/}
//                 {/*        <PrivateRoutes*/}
//                 {/*            component={ProjectPage}*/}
//                 {/*            path={process.env.REACT_APP_FRONTEND_PATH_PROJECTPAGE}*/}
//                 {/*            title={process.env.REACT_APP_FRONTEND_TITLE_PROJECTPAGE}*/}
//                 {/*            exact*/}
//                 {/*        />*/}
//                 {/*        <PrivateRoutes*/}
//                 {/*            component={TaetigkeitsberichtPage}*/}
//                 {/*            path={process.env.REACT_APP_FRONTEND_PATH_TAETIGKEITSBERICHTPAGE}*/}
//                 {/*            title={process.env.REACT_APP_FRONTEND_TITLE_TAETIGKEITSBERICHTPAGE}*/}
//                 {/*            exact*/}
//                 {/*        />*/}
//                 {/*        <PrivateRoutes*/}
//                 {/*            component={GeraetePage}*/}
//                 {/*            path={process.env.REACT_APP_FRONTEND_PATH_GERAETEPAGE}*/}
//                 {/*            title={process.env.REACT_APP_FRONTEND_TITLE_GERAETEPAGE}*/}
//                 {/*            exact*/}
//                 {/*        />*/}
//                 {/*        <PrivateRoutes*/}
//                 {/*            component={MaterialPage}*/}
//                 {/*            path={process.env.REACT_APP_FRONTEND_PATH_MATERIALPAGE}*/}
//                 {/*            title={process.env.REACT_APP_FRONTEND_TITLE_MATERIALPAGE}*/}
//                 {/*            exact*/}
//                 {/*        />*/}
//                 {/*    </>*/}
//                 {/*)}*/}
//
//
//
//             </Switch>
//         </Router>
//     );
// }
//
// export default memo(Routes);
